import { combineReducers } from '@reduxjs/toolkit'
import { organizationSlice } from './organizations.slice'
import { contractSlice } from './contracts.slice'
import { creativeSlice } from './creative.slice'
import { addressSlice } from './address.slice'
import { reportsSlice } from './report.slice'
import { platformSlice } from './platforms.slice'
import { logSlice } from './logs.slice'
import { statusesSlice } from './statuses.slice'

export * from './address.slice'
export * from './contracts.slice'
export * from './creative.slice'
export * from './logs.slice'
export * from './organizations.slice'
export * from './platforms.slice'
export * from './report.slice'
export * from './statuses.slice'
export const advertisementReducers = combineReducers({
	[organizationSlice.name]: organizationSlice.reducer,
	[contractSlice.name]: contractSlice.reducer,
	[creativeSlice.name]: creativeSlice.reducer,
	[reportsSlice.name]: reportsSlice.reducer,
	[addressSlice.name]: addressSlice.reducer,
	[platformSlice.name]: platformSlice.reducer,
	[logSlice.name]: logSlice.reducer,
	[statusesSlice.name]: statusesSlice.reducer,
})
